var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 129,
    viewBox: "0 0 123 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.1053,
    cy: 64.5,
    rx: 61.1053,
    ry: 64.5,
    fill: "#F7E0BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse2);
export default __webpack_public_path__ + "static/media/Ellipse 2.897cf6187fc4880cfcae222bc70946bc.svg";
export { ForwardRef as ReactComponent };